import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';

import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from '@angular/forms';
import { AppComponent } from '../../app.component';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';
import { ExcelService } from '../../services/excel.service';
import * as moment from 'moment';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, startWith, Subject, Subscription, takeUntil } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { postServiceWorkerMessage } from 'src/serviceworker/message';
import { WorkerMessageType } from 'src/serviceworker/service/events/message';
import { WorkerUrlPrefetchResult } from 'src/serviceworker/service/prefetch';
import { LoggerService } from 'src/app/services/logger.service';
import { decompress } from 'compress-json';
import { SocketAdvisorService } from 'src/app/services/socket-advisor.service';
import { ToastrService } from 'ngx-toastr';
import { Store } from '@ngrx/store';
import { selectAdvisorData, selectAdvisorError, selectAdvisorLoading } from 'src/app/state/selectors/advisors.selector';
import { loadAdvisorData, loadAdvisorDataSuccess } from 'src/app/state/actions/advisors.actions';
import { selectLanguageData } from 'src/app/state/selectors';
import { loadLanguageData } from 'src/app/state/actions';

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}
declare var $: any;
@Component({
  selector: 'app-manage-brokers-new',
  templateUrl: './manage-brokers-new.component.html',
  styleUrls: ['./manage-brokers-new.component.css'],
  providers: [DatePipe],
})
export class ManageBrokersNewComponent implements OnDestroy, OnInit {
  brokerList: Array<any> = [];

  dateFormat = 'YYYY-MM-DD';
  message: string
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;

  dtOptions: DataTables.Settings = {};
  dtOptions2: DataTables.Settings = {};
  persons: Array<any> = [];

  loader: boolean
  dtTrigger: Subject<any> = new Subject<any>();
  dtTrigger1: Subject<any> = new Subject<any>();
  dtTrigger2: Subject<any> = new Subject<any>();
  dtTrigger3: Subject<any> = new Subject<any>();
  dtTrigger4: Subject<any> = new Subject<any>();



  customerslist: Array<any> = [];
  role: any;
  allBrokerList: any[];
  corporates: any;
  customerList: Array<any> = [];
  customerList1: Array<any> = [];
  countCustomerList: Array<any> = [];
  FinalcountCustomerList: Array<any> = [];
  showViewButtonDisabled: boolean = false;
  showListButtonDisabled: boolean = false;
  customerListStatus: Array<any> = [];
  customersplanslist: Array<any> = [];
  selectedSubBroker: any;
  selectedForView: any;
  selectedPlanCustomer: any
  basicDetails: any;
  ParentName: any;
  brokerType: any;
  BrokerName: any;
  showdata: boolean = false
  subBrokers: any;
  showSubbroker: boolean
  disablesubBrokers: boolean = true
  disableCustomers: boolean = true
  isSubscribed: boolean;
  isAdvisor: boolean;
  checkboxesForMail: any;
  ccCheckboxesForMail: any;
  public lang: any = {};
  selectedLanguage: string;
  languageData: any;
  filterValue: String = '';
  currentPage: number = 1;
  itemsPerPage: number = 10;
  private socketSubscription: Subscription;
  restLoader: boolean = true;
  loading$: Observable<boolean>;
  error$: Observable<string | null>;
  advisorData$: Observable<any>; 
  languageData$: Observable<any>; 
  private destroy$ = new Subject<void>();
  sortColumn: string = 'name';
  sortOrder: 'ASC' | 'DESC' = 'ASC';
  inviteEmailId:any=0;

  constructor(
    private logger: LoggerService,
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private route: ActivatedRoute,
    private http: HttpClient,
    public router: Router,
    private datePipe: DatePipe,
    private excelService: ExcelService,
    private socketAdvisorService: SocketAdvisorService,
    private store: Store<{ advisorData: [], languageData: [] }>
  ) {
    this.advisorData$ = store.select(selectAdvisorData);
    this.loading$ = store.select(selectAdvisorLoading);
    this.error$ = store.select(selectAdvisorError);
    this.languageData$ = store.select(selectLanguageData);
   }
  ngOnInit() {
    this.getLanguageTokens()
    this.isSubscribed = false;
    this.loader = false
    this.role = sessionStorage.getItem('role');
    this.dtOptions = {
      pagingType: 'simple_numbers',
      // order: [],
      language: {
        searchPlaceholder: 'Search here'
      },
      destroy: true,
      ordering: true,
      // columnDefs: [
      //   {
      //     targets: '_all', // Index of the 'id' column
      //     orderable: false, // Disable sorting for this column
      //   },
      // ],
    };
    this.dtOptions2 = {
      pagingType: 'simple_numbers',
      language: {
        searchPlaceholder: 'Search here'
      },
      destroy: true,
      ordering: true,
      columnDefs: [
        {
          targets: [4],
          type: 'date'
        },
      ],
    };
    this.getBrokerList()
    // this.getServiceWorkerDetails()

    let role = sessionStorage.getItem('role')
    if(role == 'ADMINISTRATOR'){
      this.initAdvisorSocket()
    }
  }

  initAdvisorSocket() {
    console.log('AdvisorGateway', 'Initialized');
    this.socketSubscription = this.socketAdvisorService
      .listen('advisorUpdated')
      .subscribe((data) => {
        console.log(data)
        if (data && data.message) {
          this.toastrService.warning(data.message, '', { timeOut: 3000 });
        }
      });
  }

  public getLanguageTokens(){
    // let body= {
    //   "project":"Admin Portal",
    //   "url":"manageAdvisors"
    // }
    // this.http
    // .post('https://languageengineapi.aitestpro.com/string/project-url-strings',body, {
    //   headers: {
    //     'Content-Type': 'application/json',
    //   },
    // })
    // .subscribe(
    //   (response: any) => {
    //     console.log(response)
    //     this.lang = {};
    //     this.languageData = response.strings
    //     this.selectedLanguage = sessionStorage.getItem("language")
    //     for (let token of response.strings) {
    //       this.lang[token.key] = token[this.selectedLanguage];
    //     }
    //   })

    // this.store.dispatch(loadLanguageData());
    
    this.languageData$ = this.store.select(state => state.languageData).pipe(
      startWith([]),
      takeUntil(this.destroy$)
    );

    this.languageData$.subscribe(data => {
      if(data){
        // console.log(data)
        if (data?.languageData == undefined || Object.keys(data.languageData).length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        // if(Object.keys(this.lang).length>0){
        //   return;
        // }
        setTimeout(()=>{
          this.lang = {};
          this.languageData = data?.languageData
          this.selectedLanguage = sessionStorage.getItem("language")
          for (let token of data?.languageData) {
            this.lang[token.key] = token[this.selectedLanguage];
          }
          // console.log('this.lang',this.lang)
        },0)
      }
    })
  }
  checkCount(c) {
    if (c > 0) { return false }
    return true
  }

  // getServiceWorkerDetails() {
  //   var getClients = '/api/ap/brokers/details';


  //   let prefetchurls = []

  //   let Data = [{
  //     url: environment.apiUrl + getClients,
  //     // fetch options
  //     options: {

  //       mode: 'cors',
  //       headers: {

  //         Authorization: 'Bearer ' + sessionStorage.getItem('accessToken'),
  //         'Content-Type': 'application/json',
  //       }
  //     }
  //   }]
  //   prefetchurls = Data

  //   setTimeout(() => {
  //     postServiceWorkerMessage(WorkerMessageType.Prefetch, prefetchurls).then((results: WorkerUrlPrefetchResult) => {
  //       $("#dataTableId").dataTable().fnDestroy();

  //       // this._LoaderService.HideLoader()
  //       setTimeout(() => {
  //         this.brokerList = results[0].response.data

  //         this.allBrokerList = this.brokerList;

  //         this.brokerList.sort((a, b) => {

  //           const order = { true: 1, false: 2, };

  //           if (order[a.status] !== order[b.status]) {
  //             return order[a.status] - order[b.status];
  //           }
  //           return a.name.trim().localeCompare(b.name.trim());
  //         });

  //         this.dtTrigger.next(null);
  //       }, 500);
  //     })
  //   }, 1000);


  // }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger1.next(null);
    });
  }

  @ViewChild(ConfirmationDialogComponent) confirmationDialog: ConfirmationDialogComponent;

  invitationMail(id: any) {
    this.confirmationDialog.confirmed.subscribe(obj => {
      if (obj.confirmed) {
        var accessToken = sessionStorage.getItem('accessToken');
        var brokerStatus = '/api/ap/member/' + id + '/inviteMail/'
        this.logger.log('invition Id', id)


        this.http
          .get(environment.apiUrl + brokerStatus, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe(
            (response: any) => {
              if (response['status'] == 200 || response['statusCode'] == 200) {
                // this.getclientList()
                // window.location.reload()
                Swal.fire({ title: this.lang.Info, text: response.message })
              } else {
                Swal.fire({ title: this.lang.Error??'Error', text: response.message })
              }
            },
            (error) => {
              if (
                error.status == 400 ||
                error.status == 401 ||
                error.status == 402 ||
                error.status == 403
              ) {
                Swal.fire({
                  title: this.lang.Error??'Error',
                  text: error.error.error.message,
                  showDenyButton: false,
                  showCancelButton: false,
                  // confirmButtonText: this.lang.Proceed,
                }).then((result) => {
                  if (result.isConfirmed) {
                  }
                  else {
                  }
                });
              } else {
                // Swal.fire(error.error.error.message)
                Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
              }
              // this.toastrService.error("Invalid Credentials", 'Error!');
            }
          );

      }
    });
  }

  invitationAdvisor(broker: any) {
    this.inviteEmailId = broker.id;
    this.isAdvisor = true
    // this.message = this.lang.Send +`${broker.name}`  +  this.lang.portal_access_link_to
    this.message = `${this.lang.Send} <b>${broker.name}</b> &nbsp;${this.lang.portal_access_link_to}`;

    const accessToken = sessionStorage.getItem('accessToken');

    function capitalizeWords(str) {
      return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    }

    const getGroupContacts = `/api/ap/broker/${this.inviteEmailId}/groupContact`;
    this.loader = true
    this.http.get(environment.apiUrl + getGroupContacts, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      this.loader = false
      if (response['status'] == 200 || response['statusCode'] == 200) {
        const checkboxes = response.data.brokerAdmins
        if (checkboxes.length <= 0) {
          Swal.fire({ title: this.lang.Info, text: this.lang.Please_add_atleast_one_group_contact_to_send_the_Mail })
          return
        }
        this.ccCheckboxesForMail = broker.ccMails.map((c: any, i: number) => {
          const obj = {
            label: c,
            checked: false
          }
          return obj;
        })

        this.checkboxesForMail = checkboxes.map((c: any, i: number) => {
          const obj = {
            label: `${c.role == "ADVISOR_OTHERS" ? capitalizeWords(c.roleName) : c.roleNameDisplay || c.role} ${c.firstName} ${c.lastName} {${c.email}}`,
            checked: false,
            id: c.groupAdminId
          }
          return obj;
        }
        )
        this.adviserInvitation(broker)
      } else {
        Swal.fire({ title: this.lang.Error??'Error', text: response.message })
      }
    }), (error) => {
      this.loader = false
      Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
    }

    this.logger.log("checboxes", this.checkboxesForMail)

  }

  adviserInvitation(broker: any) {


    $('#confirmationModal').modal('show');
    if (!this.isSubscribed) {
      this.confirmationDialog.confirmed.subscribe(obj => {
        this.isSubscribed = true;
        if (obj.confirmed) {
          this.logger.log(obj)
          const payload = {
            groupAdmins: obj.selectedCheckboxes.map((o, i) => (o.id)),
            ccList: obj.selectedCcCheckboxes.map((o) => (o.label))
          }

          var accessToken = sessionStorage.getItem('accessToken');
          var GetBrokers = `/api/ap/broker/${this.inviteEmailId}/invitation`;

          this.http
            .post(environment.apiUrl + GetBrokers, payload, {
              headers: {
                Authorization: 'Bearer ' + accessToken,
                'Content-Type': 'application/json',
              },
            })
            .subscribe(
              (response: any) => {
                if (response['status'] == 200 || response['statusCode'] == 200) {

                  Swal.fire({ title: this.lang.Info, text: response.message })
                } else {
                  Swal.fire({ title: this.lang.Error??'Error', text: response.message })
                }
              },
              (error) => {
                if (
                  error.status == 400 ||
                  error.status == 401 ||
                  error.status == 402 ||
                  error.status == 403
                ) {
                  Swal.fire({
                    title: this.lang.Error??'Error',
                    text: error.error.error.message,
                    showDenyButton: false,
                    showCancelButton: true,
                    confirmButtonText: this.lang.Proceed,
                  }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                  });
                } else {
                  // Swal.fire(error.error.error.message)
                  Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
                }
                // this.toastrService.error("Invalid Credentials", 'Error!');
              }
            );
        }
        $('#confirmationModal').modal('hide');
      })
    }
  }

  viewsubBrokerList(brokerlist, filter: any, brokerName: string, brokerId: any) {
    this.selectedForView = brokerName.length > 80 ? brokerName.substring(0, 80) + '...' : brokerName
    this.customerList = []

    if (filter == 'viewAll') {
      this.showSubbroker = true
      $('#subGroupList-modal').modal('show');
      this.logger.log(brokerlist);

      [...brokerlist].sort((a, b) => {
        const order = { 'TPA/MGA': 1, STUDENT_ASSOCIATION: 2, BROKERAGE: 3, ASSOCIATION: 4, ADVISOR: 5, CORPORATE: 6 };
        if (order[a.brokerType] !== order[b.brokerType]) {
          return order[a.brokerType] - order[b.brokerType];
        }
        return a.name.trim().localeCompare(b.name.trim())
      });
      this.customerslist = brokerlist;
    }

    else if (filter == 'corporates') {
      this.showSubbroker = false
      $('#subGroupList-modal').modal('show');
      this.corporates = brokerlist.filter(broker => broker.brokerType.toLowerCase() == 'corporate');
      this.corporates.sort((a, b) => a.name.localeCompare(b.name));
      this.customerslist = this.corporates;
      this.logger.log({ corp: this.customerList })
    }

    this.dtTrigger1.next(null);


    this.logger.log(this.showSubbroker)
  }

  public viewBrokerCustomers(broker: any, index: number) {
    this.logger.log({ broker })
    this.disablesubBrokers = false
    this.selectedSubBroker = broker.name.length > 80 ? broker.name.substring(0, 80) + '...' : broker.name

    $('#customersList').modal('show')

    // $('#DataTables_Table_1').dataTable().fnDestroy();
    $('#DataTables_Table_2').dataTable().fnDestroy();
    this.customerList1 = []
    this.getCustomerDetails(broker.id)
  }

  gotomemberDetails(customer:any){


    $('#customersList').modal('hide')
    $('#subGroupList-modal').modal('hide');
    $('#countList').modal('hide')

    this.router.navigate(['/manageMembers/employee/' + customer.uId + '/details']);

  }

  naviagtetoportal(broker:any){
    $('#subGroupList-modal').modal('hide');

    if(broker.brokerType=="ADVISOR"){
      this.router.navigate(['/manageAdvisors/' + broker.id + '/viewAdvisor']);
    }
    if(broker.brokerType=="CORPORATE"){
      // this.router.navigate(['/manageCorporates/' + broker.id + '/view']);
      // console.log(broker)

      const showTiles = broker.adminApproved;
      if (showTiles) {
        this.router.navigate(['/manageCorporates/' + broker.id + '/view']);
      } else {
        this.router.navigate(['/manageCorporates/edit-corporate/' + broker.id]);
      }

    }
  }
  getCustomerDetails(brokerId) {

    var accessToken = sessionStorage.getItem('accessToken');
    // /api/ap / broker / 10 / customers / details'
    var GetBrokersDetails = '/api/ap/broker/' + brokerId + '/customers/details';

    this.http
      .post(environment.apiUrl + GetBrokersDetails, {}, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200 || response['statusCode'] == 200) {

            this.logger.log(response.data.customers)
            this.customerList = response.data.employees
            this.basicDetails = response.data
            this.ParentName = this.basicDetails?.parent?.name
            this.brokerType = this.basicDetails.brokerType
            this.BrokerName = this.basicDetails.name
            this.showdata = true
            if (this.customerList.length < 0) {
              this.showViewButtonDisabled = true
            }
            var arr = []

            for (let i = 0; i < this.customerList.length; i++) {
              arr.push(this.customerList[i].status)
              this.customerListStatus = arr.filter((item,
                index) => arr.indexOf(item) === index);
              if (this.customerList[i].status == "Active") {
                this.customerList1.push(this.customerList[i])
              }
              this.customerList1 = this.customerList1.sort((a, b) => (a.firstName.trim().localeCompare(b.firstName.trim())));


            }

            this.logger.log("customerlist", this.customerList1)

            $("#DataTables_Table_2").dataTable().fnDestroy();
            this.dtTrigger2.next(null);

          }
          else {
            Swal.fire({ title: this.lang.Error??'Error', text: response.message })
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error??'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'OK',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
          }
        }
      );
  }

  viewsupersubbrokerList(broker) {
    this.disablesubBrokers = false
    this.subBrokers = []
    this.selectedSubBroker = broker.name.length > 80 ? broker.name.substring(0, 80) + '...' : broker.name
    this.getSuperSubBrokers(broker)
    $("#supersubList-modal").modal('show')


  }

  getSuperSubBrokers(broker) {
    var corporateId = sessionStorage.getItem('corporateId');
    var accessToken = sessionStorage.getItem('accessToken');
    var GetBrokers = `/api/ap/broker/${broker.id}/subBrokers`;
    this.http
      .get(environment.apiUrl + GetBrokers, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200 || response['statusCode'] == 200) {
            this.subBrokers = response.data.subBrokers.sort((a, b) => (a.name.trim().localeCompare(b.name.trim())))
            if (this.subBrokers.length < 1) {
              this.showListButtonDisabled = true;
            }
            else {
              this.showListButtonDisabled = false;

            }
            this.logger.log("subBrokers", this.subBrokers, "length", this.subBrokers.length, this.showListButtonDisabled)
          } else {
            Swal.fire({ title: this.lang.Error??'Error', text: response.message })
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error??'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: true,
              confirmButtonText: this.lang.Proceed,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
  }



  getCountCustomers(brokerId, subBrokerIds) {

    var accessToken = sessionStorage.getItem('accessToken');
    var GetBrokersDetails = '/api/ap/brokers/customers';
    let data = { brokerIds: [brokerId, ...subBrokerIds] }
    // var GetBrokersDetails = '/api/ap/broker/' + 1044 + '/details';


    this.http
      .post(environment.apiUrl + GetBrokersDetails, data, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200 || response['statusCode'] == 200) {

            this.logger.log(response.data.employees)


              this.countCustomerList = response.data.employees.sort((a, b) => {
                const order = { Active: 1, Incomplete: 2, Hold: 3, Cancelled: 4, Draft: 5, Suspended: 6 };

                if (order[a.status] !== order[b.status]) {
                  return order[a.status] - order[b.status];
                }
                return a.firstName.trim().localeCompare(b.firstName.trim());
              });



              console.log(this.countCustomerList)

              $("#DataTables_Table_4").dataTable().fnDestroy();
              this.dtTrigger4.next(null);






            // $('#yourTableId').DataTable().destroy();



          }
          else {
            Swal.fire({ title: this.lang.Error??'Error', text: response.message })
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error??'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'OK',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
          }
        }
      );
  }

  viewCountCustomers(brokerName: any, brokerId: any, subBrokerIds: any) {
    this.logger.log({ brokerName })
    this.selectedSubBroker = brokerName.length > 80 ? brokerName.substring(0, 80) + '...' : brokerName

    $('#countList').modal('show')


    this.getCountCustomers(brokerId, subBrokerIds)
  }

  viewcustomerPlansList(brokerlist, firstName, lastName) {
    this.logger.log({ brokerlist })
    this.disableCustomers = false;
    this.selectedPlanCustomer = `${firstName} ${lastName}`

    $('#customerPlansList-modal').modal('show');

    this.customersplanslist = brokerlist

    $("#DataTables_Table_3").dataTable().fnDestroy();
    this.dtTrigger3.next(null);

  }

  closePopup() {
    $("#DataTables_Table_1").dataTable().fnDestroy();
  }


  closeplansList() {
    this.disableCustomers = true;
    $("#DataTables_Table_3").dataTable().fnDestroy();
  }

  closeCountList() {
    // $("#DataTables_Table_4").dataTable().fnDestroy();
  }


  closeGigList() {
    $("#DataTables_Table_1").dataTable().fnDestroy();
    this.dtTrigger.next(null);
  }

  changeStatus(e: any) {
    $("#dataTableId").dataTable().fnDestroy();
    this.brokerList = [];

    let val = e.target.value.toLowerCase();//member.status.toLowerCase()==val
    if (val == 'all') {
      this.brokerList = this.allBrokerList;
    } else {
      this.brokerList = this.allBrokerList.filter((member) => {
        if (member.status?.toString().toLowerCase() == val) {
          return member;
        }
      });
    }
    // this.dtTrigger.next(null);
    // this.dtTrigger.unsubscribe();
    this.dtTrigger.next(null);
    this.logger.log(this.brokerList);
  }

  public viewBrokerDetails(broker: any, index: number) {

    // this.router.navigate(['/manageAdvisors/editAdvisor/' + broker.id]);
    this.router.navigate(['/manageAdvisors/' + broker.id + '/viewAdvisor']);


    // /broker/{brokerId}/details

  }


  public addBrokerDetails() {
    this.router.navigate(['/manageAdvisors/addAdvisor']);

  }
  scrollTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  // public getBrokerList() {

  //   var corporateId = sessionStorage.getItem('corporateId');
  //   var accessToken = sessionStorage.getItem('accessToken');
  //   // var GetBrokers = '/api/ap/brokers/details';
  //   const role = sessionStorage.getItem('role')
  //   let GetBrokers = ''
  //   if(role=='ADMINISTRATOR'){
  //     // GetBrokers = 'http://[::1]:3002/api/ap/global/adminAdvisors';
  //     GetBrokers = '/api/ap/global/adminAdvisors';
  //   }else{
  //     GetBrokers = '/api/ap/brokers/details';
  //   }
  //   const that = this;

  //   this.loader = true;
  //   this.http
  //     .get(environment.apiUrl + GetBrokers, {
  //     // .get( GetBrokers, {
  //       headers: {
  //         Authorization: 'Bearer ' + accessToken,
  //         'Content-Type': 'application/json',
  //       },
  //     })
  //     .subscribe(
  //       (response: any) => {
  //         this.loader = false;
  //         if (response['status'] == 200 || response['statusCode'] == 200) {
  //           setTimeout(() => {
  //             // this.brokerList = (response as any).data;
  //             if(role=='ADMINISTRATOR'){
  //               this.brokerList = decompress(decompress(response.data))
  //             }else{
  //               this.brokerList = response.data
  //             }

  //             this.allBrokerList = this.brokerList;
  //             // this.brokerList=this.brokerList.sort((a, b)=>{
  //             //   const order={true :1,false:2};
  //             //   return order[a.status]-order[b.status]
  //             // })
  //             this.brokerList.sort((a, b) => {

  //               const order = { true: 1, false: 2, };

  //               if (order[a.status] !== order[b.status]) {
  //                 return order[a.status] - order[b.status];
  //               }
  //               return a.name.trim().localeCompare(b.name.trim());
  //             });

  //             this.dtTrigger.next(null);
  //             this.restLoader = false
  //           }, 500);


  //           // this.http.get(environment.apiUrl+'/api/ap/global/set-adminAdvisors').subscribe((newResponse) => {})

  //         } else {
  //           this.loader = false;
  //           Swal.fire({ title: this.lang.Error??'Error', text: response.message })
  //         }
  //       },
  //       (error) => {
  //         this.loader = true;
  //         if (
  //           error.status == 400 ||
  //           error.status == 401 ||
  //           error.status == 402 ||
  //           error.status == 403
  //         ) {
  //           Swal.fire({
  //             title: "Error",
  //             text: error.error.error.message,
  //             showDenyButton: false,
  //             showCancelButton: false,
  //             confirmButtonText: "Proceed",
  //           }).then((result) => {
  //             /* Read more about isConfirmed, isDenied below */
  //             if (result.isConfirmed) {
  //               sessionStorage.clear();
  //               this.router.navigate(['/login']);
  //             }
  //             else {
  //               sessionStorage.clear();
  //               this.router.navigate(['/login']);
  //             }
  //           });
  //         } else {
  //           // Swal.fire(error.error.error.message)
  //           Swal.fire({ title: 'Error', text: error.error.error.message });
  //         }
  //         // this.toastrService.error("Invalid Credentials", 'Error!');
  //       }
  //     );
  // }

  public getBrokerList() {
    this.store.dispatch(loadAdvisorData());
    this.advisorData$ = this.store.select(state => state.advisorData).pipe(
      startWith([]),
      takeUntil(this.destroy$)
    );
    this.advisorData$?.subscribe(data => {
      if (data) {
        console.log(data)
      if ((data?.advisorData == undefined || Object.keys(data.advisorData).length <= 0) && data?.loading == true) {
        console.log('No data to process', new Date().toISOString());
        return;
      }
      if(this.brokerList.length>0 && data?.loading==false){
        return;
      }

      const role = sessionStorage.getItem('role');
      if(role=='ADMINISTRATOR'){
        this.brokerList = [...data?.advisorData]
        // this.brokerList = decompress(decompress(data.advisorData))
      }else{
        this.brokerList = [...data?.advisorData]
      }
      this.brokerList = this.brokerList.map((broker)=>{
        return{
          ...broker,
          published: !broker.published || broker.published == undefined || broker.published == null ? 'Inactive' : 'Active'
        }
      })
      setTimeout(()=>{
        this.allBrokerList = this.brokerList;
        this.brokerList = this.brokerList.filter((broker: any) => broker.name!=null && broker.name!=undefined).sort((a, b) => {
          const order = { true: 1, false: 2, };
          if (order[a.status] !== order[b.status]) {
            return order[a.status] - order[b.status];
          }
          return a.name.trim().localeCompare(b.name.trim());
        });
        this.restLoader = false;
        setTimeout(() => {
          this.dtTrigger.next(null);
        }, 0);
      },0)
      } else {
        console.error('Observable returned undefined');
      }
    })
  }

  get filteredAndPaginatedAdvisors() {
    const filteredAdvisors = this.brokerList.filter(member => {
      return Object.values(member).some(value =>
        String(value).toLowerCase().includes(this.filterValue.toLowerCase())
      );
    });

    // Sort the filtered corporates based on the current sort column and order
    if (this.sortColumn) {
      filteredAdvisors.sort((a, b) => {
        
        if(this.sortColumn=='name'){
          if(this.sortOrder === 'ASC'){
            return a.name.trim().localeCompare(b.name.trim());
          }else{
            return b.name.trim().localeCompare(a.name.trim());
          }
        }
        // let valueA = a[this.sortColumn] != undefined && a[this.sortColumn] != null ? a[this.sortColumn] : '';
        // let valueB = b[this.sortColumn] != undefined && b[this.sortColumn] != null ? b[this.sortColumn] : '';
        let valueA = this.getNestedValue(a, this.sortColumn) || '';
        let valueB = this.getNestedValue(b, this.sortColumn) || '';
  
        // If the value is a boolean, convert to 1 or 0 for sorting
        if (typeof valueA == 'boolean') {
          valueA = valueA ? 1 : 0;
        }
        if (typeof valueB == 'boolean') {
          valueB = valueB ? 1 : 0;
        }
  
        // Trim and normalize strings (to lower case) for comparison
        if (typeof valueA == 'string') {
          valueA = valueA.trim().toLowerCase();
        }
        if (typeof valueB == 'string') {
          valueB = valueB.trim().toLowerCase();
        }
  
        // Handle dates
        if (typeof valueA == 'string' && Date.parse(valueA)) {
          valueA = new Date(valueA);
        }
        if (typeof valueB == 'string' && Date.parse(valueB)) {
          valueB = new Date(valueB);
        }

        // Compare strings alphabetically
        if (typeof valueA == 'string' && typeof valueB == 'string') {
          // if (valueA < valueB) {
          //   return this.sortOrder === 'ASC' ? -1 : 1;
          // }
          // if (valueA > valueB) {
          //   return this.sortOrder === 'ASC' ? 1 : -1;
          // }
          valueA = this.normalizeString(valueA);
          valueB = this.normalizeString(valueB);
          if(this.sortOrder === 'ASC'){
            return valueA.localeCompare(valueB);
          }else{
            return valueB.localeCompare(valueA);
          }
        }
  
        // Compare numbers
        if (typeof valueA == 'number' && typeof valueB == 'number') {
          if (valueA < valueB) {
            return this.sortOrder === 'ASC' ? -1 : 1;
          }
          if (valueA > valueB) {
            return this.sortOrder === 'ASC' ? 1 : -1;
          }
        }
  
        // Compare dates (after parsing string to Date)
        if (valueA instanceof Date && valueB instanceof Date) {
          return this.sortOrder === 'ASC' ? valueA.getTime() - valueB.getTime() : valueB.getTime() - valueA.getTime();
        }
  
        return 0;
      });
    }

    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    return filteredAdvisors.slice(startIndex, startIndex + this.itemsPerPage);
  }

  getNestedValue(obj: any, path: string) {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj);
  }

  sortTable(column: string): void {
    console.log('Sorting by column:', column);

    // Toggle the sort order if the same column is clicked
    if (this.sortColumn == column) {
      this.sortOrder = this.sortOrder === 'ASC' ? 'DESC' : 'ASC';
    } else {
      // Default to ascending order if a new column is clicked
      this.sortColumn = column;
      this.sortOrder = 'ASC';
    }
  }

  normalizeString(value: string): string {
    return value.replace(/[^\w\s]/g, '').toLowerCase().trim();
  }

  totalPages() {
    // return Math.ceil(this.members.length / this.itemsPerPage);
    const filteredMembers = this.brokerList.filter(member => {
      return Object.values(member).some(value =>
        String(value).toLowerCase().includes(this.filterValue.toLowerCase())
      );
    });
    return Math.ceil(filteredMembers.length / this.itemsPerPage);
  }

  nextPage() {
    if (this.currentPage < this.totalPages()) {
      this.currentPage++;
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  public deletebrokerDetails(broker: any, index: any) {

    this.logger.log(broker)
    // this.logger.log(index)
    var accessToken = sessionStorage.getItem('accessToken');
    var deleteBroker = '/api/ap/broker/' + broker.id + ''


    Swal.fire({
      title: this.lang.Alert,
      text: this.lang.Are_you_sure_you_want_to_delete_this + broker.brokerType + '?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: this.lang.Proceed,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {

        this.http
          .delete(environment.apiUrl + deleteBroker, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe(
            (response: any) => {
              if (response['status'] == 200 || response['statusCode'] == 200) {
                // this.dtTrigger.next("");
                window.location.reload()
                // this.getBrokerList()
              } else {
                Swal.fire({ title: this.lang.Error??'Error', text: response.message })
              }
            },
            (error) => {
              if (
                error.status == 400 ||
                error.status == 401 ||
                error.status == 402 ||
                error.status == 403
              ) {
                Swal.fire({
                  title: this.lang.Error??'Error',
                  text: error.error.error.message,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.lang.Proceed,
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                  else {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                });
              } else {
                // Swal.fire(error.error.error.message)
                Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
              }
              // this.toastrService.error("Invalid Credentials", 'Error!');
            }
          );
      }
    })

  }

  public brokerStatus(broker: any, event: any, index: number) {
    $("#dataTableId").dataTable().fnDestroy();

    var accessToken = sessionStorage.getItem('accessToken');
    var brokerStatus = '/api/ap/broker/' + broker.id + '/activation/' + event

    Swal.fire({
      title: this.lang.Alert,
      text: this.lang.Are_you_sure_you_want_to_change_this + broker.brokerType + this.lang.status+"?",
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: this.lang.Proceed,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {

        this.http
          .get(environment.apiUrl + brokerStatus, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe(
            (response: any) => {
              if (response['status'] == 200 || response['statusCode'] == 200) {
                // window.location.reload()
              } else {
                Swal.fire({ title: this.lang.Error??'Error', text: response.message })
              }
            },
            (error) => {
              if (
                error.status == 400 ||
                error.status == 401 ||
                error.status == 402 ||
                error.status == 403
              ) {
                Swal.fire({
                  title: this.lang.Error??'Error',
                  text: error.error.error.message,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.lang.Proceed,
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                  else {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                });
              } else {
                // Swal.fire(error.error.error.message)
                Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
              }
              // this.toastrService.error("Invalid Credentials", 'Error!');
            }
          );
      }
      else {
        this.getBrokerList()
        // window.location.reload()
      }
    })

  }


  closeCustomersList() {
    // $("#DataTables_Table_2").dataTable().fnDestroy();
    this.disablesubBrokers = true
    // this.dtTrigger1.next(null);
  }

  closeSuperSubList() {
    // $("#DataTables_Table_1").dataTable().fnDestroy();
    this.disablesubBrokers = true
    // this.dtTrigger1.next(null);
  }


  filtercustomerstatus(e, status) {
    this.logger.log(e)
    this.logger.log(e.target.value)

    $("#DataTables_Table_2").dataTable().fnDestroy();
    this.dtTrigger2.next(null);

    if (e.target.value != "All") {
      this.customerList1 = []
      for (let i = 0; i < this.customerList.length; i++) {
        if (this.customerList[i].status == e.target.value) {
          this.customerList1.push(this.customerList[i])
        }
      }
      this.customerList1 = this.customerList1.sort((a, b) =>
        a.firstName > b.firstName ? 1 : -1
      );
    }
    else {
      this.customerList1 = this.customerList.sort((a, b) =>
        a.firstName > b.firstName ? 1 : -1
      );
    }
  }





  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
    // this.http.get(environment.apiUrl+'/api/ap/global/set-adminAdvisors').subscribe(()=>{})
    // this.store.dispatch(loadAdvisorDataSuccess({advisorData:[]}));
    // this.store.dispatch(loadAdvisorData());

    console.log('AdvisorGateway', 'Destroyed');
    this.socketAdvisorService.disconnect();
    if (this.socketSubscription) {
      this.socketSubscription.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }
}
export function moments(date: string | undefined): moment.Moment {

  if (date)

    return moment((new Date(date)).toJSON())

  else

    return moment();

}
